import { IPolicy } from '@verzekeringapp-mono/shared/src/models/policy'
import React from 'react'

interface IProps {
  policy: IPolicy
}

const PolicyConditions: React.FC<IProps> = ({ policy }) => (
  <>
    {policy.conditions && policy.conditions.length > 0 && (
      <div className='flex flex-col gap-4'>
        <p className='subtitle'>Polisvoorwaarden</p>

        {policy.conditions.map((condition) => (
          <button
            key={condition.id}
            className='primary-btn w-full max-w-[500px]'
            style={{ minWidth: 0 }}
            onClick={() => window.open(condition.url, '_blank')}
          >
            <span className='block w-full overflow-hidden text-ellipsis whitespace-nowrap text-center'>{condition.description}</span>
          </button>
        ))}
      </div>
    )}
  </>
)

export default PolicyConditions
